var map = {
	"./apiladores/apilador.png": 72,
	"./apiladores/detalleProducto/apilador.png": 73,
	"./background.png": 74,
	"./bolatransferencia/boladetransferencia.png": 75,
	"./bolatransferencia/detalleProducto/boladetransferencia.png": 76,
	"./carousel/apilador.png": 26,
	"./carousel/carrito_elevador.png": 27,
	"./carousel/edit_bola.png": 28,
	"./carousel/escalera_telescopica.png": 29,
	"./carousel/grua_pluma_5.png": 40,
	"./carousel/portaplasticos.png": 41,
	"./carousel/portatambor.png": 42,
	"./carousel/portatambor_verde2.png": 43,
	"./carousel/portatamboreslinga.png": 44,
	"./carousel/transpaleta_naranja_3000kg.jpg": 45,
	"./gruapluma/detalleProducto/gruapluma.jpg": 77,
	"./gruapluma/gruapluma.png": 78,
	"./logo_transeleva.png": 30,
	"./manufacturapropia/detalleProducto/elevadoreslingaparatambores.png": 79,
	"./manufacturapropia/detalleProducto/escalera_telescopica.png": 80,
	"./manufacturapropia/detalleProducto/maquina_ancho-1.png": 81,
	"./manufacturapropia/detalleProducto/porta-tambor.png": 82,
	"./manufacturapropia/detalleProducto/portatambor.png": 83,
	"./manufacturapropia/elevadoreslinga.png": 84,
	"./manufacturapropia/escaleratelescopica.png": 85,
	"./manufacturapropia/portaplasticos.png": 86,
	"./manufacturapropia/portatambor.png": 87,
	"./manufacturapropia/portatamboreslinga.png": 88,
	"./mesadetrabajo/detalleProducto/mesadetrabajo.jpg": 89,
	"./mesadetrabajo/mesadetrabajo.png": 90,
	"./portatambores/detalleProducto/portatambor.png": 91,
	"./portatambores/portatambor.png": 92,
	"./transpaletas/detalleProducto/transpaletaCBY.png": 46,
	"./transpaletas/detalleProducto/transpaletaEP-55.png": 47,
	"./transpaletas/detalleProducto/transpaletaparapasillo.png": 48,
	"./transpaletas/transpaleta1.jpg": 49,
	"./transpaletas/transpaleta2.jpg": 50,
	"./transpaletas/transpaleta3.jpg": 51,
	"./transpaletas/transpaleta5.jpg": 52,
	"./transpaletas/transpaleta7.2.jpg": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;